export default "__VITE_ASSET__CMPFS1lL__"